<template>
    <div>
        <ion-item>
            <ion-label
                position="floating"
                v-if="label !== ''"
                class="ion-text-wrap"
                >{{ label }}</ion-label
            >
            <ion-textarea
                :value="value"
                @ionChange="$emit('input', $event.detail.value)"
                :placeholder="placeholder"
                :rows="rows"
                :disabled="disabled"
                autocapitalize="on"
            ></ion-textarea>
        </ion-item>
        <input-error :id="id"></input-error>
    </div>
</template>

<script>
import InputError from "./InputError";

export default {
    components: {
        InputError,
    },
    props: {
        value: undefined,
        label: {
            type: String,
            required: false,
            default: "",
        },
        placeholder: String,
        id: {
            type: String,
            required: true,
        },
        rows: {
            type: Number,
            required: false,
            default: 3,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
ion-label {
    // --color: var(--ion-color-medium-shade) !important;
    opacity: 0.33;
}
.label-floating.sc-ion-label-md-h,
.label-stacked.sc-ion-label-md-h {
    padding-top: 8px;
}
.item-has-value {
    ion-label {
        opacity: 1;
        // --color: var(--ion-color-dark) !important;
    }
}
</style>
